import { SocialNetwork } from '@frontend/applications/Social/types';

/**
 * Returns the permalink URL to a creator's profile based on the given social network and username.
 *
 * This function supports the following platforms:
 * - Instagram: https://www.instagram.com/{username}
 * - TikTok: https://www.tiktok.com/@{username}
 * - YouTube (handles only): https://www.youtube.com/@{username}
 * - Facebook: https://www.facebook.com/{username}
 * - Pinterest: https://www.pinterest.com/{username}
 *
 * @param network - The social network to generate the URL for.
 * @param username - The creator's username or handle on the specified platform.
 * @returns The full URL to the creator's profile.
 * @throws If the social network is unsupported.
 */
export function getCreatorPermalink(network: SocialNetwork, username: string): string {
  switch (network) {
    case 'instagram':
      return `https://www.instagram.com/${username}`;
    case 'tiktok':
      return `https://www.tiktok.com/@${username}`;
    case 'youtube':
      return `https://www.youtube.com/@${username}`;
    case 'facebook':
      return `https://www.facebook.com/${username}`;
    case 'pinterest':
      return `https://www.pinterest.com/${username}`;
    default:
      throw new Error(`Unsupported social network: ${network}`);
  }
}
